import React, { useState, useEffect } from "react";
import CountrySelector from "./components/CountrySelector";
import MapView from "./components/MapView";
import KakaoLoginButton from "./components/KakaoLoginButton";
import useAuth from "./hooks/useAuth";
import axios from "axios";

function App() {
  const [selectedCity, setSelectedCity] = useState(null);
  const [sharedRestaurantId, setSharedRestaurantId] = useState(null);
  const { user, loading, logout } = useAuth();

  // 👇 토큰 처리만 추가 (기존 훅 보존)
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const error = urlParams.get('error');
    const restaurantId = urlParams.get('restaurantId');

    if (token) {
      localStorage.setItem('kakaoToken', token);
      window.history.replaceState({}, document.title, window.location.pathname);
      console.log('✅ 카카오 토큰 저장됨');
      window.location.reload();
    } else if (error) {
      console.error('❌ 로그인 에러:', error);
      localStorage.removeItem('kakaoToken');
    }

    // ✅ 공유 링크로 접속한 경우
    if (restaurantId) {
      console.log("1. restaurantId 읽음:", restaurantId);
      axios.get(`/api/restaurants/${restaurantId}`)
        .then(res => {
          console.log("2. API 응답:", res.data);
          console.log("3. 도시 이름:", res.data.city);
          const restaurant = res.data;
          setSharedRestaurantId(parseInt(restaurantId));
          setSelectedCity({ name: restaurant.city, lat: restaurant.lat, lng: restaurant.lng, zoom: 15 });
          console.log("4. setSelectedCity 완료");
          window.history.replaceState({}, document.title, window.location.pathname);
        })
        .catch(e => console.error("공유 링크 맛집 조회 실패:", e));
    }
  }, []);

  if (loading) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontSize: "18px"
      }}>
        로딩 중...
      </div>
    );
  }

  return (
    <div>
      {/* 상단 로그인/유저 정보 바 */}
      <div style={{
        position: "fixed",
        top: "10px",
        right: "10px",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        gap: "6px"
      }}>
        {user ? (
          <>
            {user.profileImage && (
              <img
                src={user.profileImage}
                alt="프로필"
                style={{
                  width: "28px",
                  height: "32px",
                  borderRadius: "50%",
                  border: "2px solid white"
                }}
              />
            )}
            <span style={{
              backgroundColor: "white",
              padding: "4px 8px",
              borderRadius: "8px",
              fontSize: "12px",
              fontWeight: "bold",
              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
              maxWidth: "80px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }}>
              {user.nickname}
            </span>
            {/* ✅ 수정 1: 게스트면 회색/로그인 텍스트, 일반유저면 빨간색/로그아웃 */}
            {/* <button
              onClick={logout}
              style={{
                backgroundColor: user.role === "GUEST" ? "#888" : "#ff4d4d",
                color: "white",
                border: "none",
                borderRadius: "8px",
                padding: "4px 8px",
                fontSize: "12px",
                cursor: "pointer"
              }}
            >
              {user.role === "GUEST" ? "로그인" : "로그아웃"}
            </button> */}
            <button
              onClick={logout}
              style={{ backgroundColor: "#ff4d4d", color: "white", border: "none", borderRadius: "8px", padding: "4px 8px", fontSize: "12px", cursor: "pointer" }}
            >
              로그아웃
            </button>
          </>
        ) : (
          <KakaoLoginButton />
        )}
      </div>

      {/* 기존 앱 화면 */}
      {!selectedCity ? (
        <CountrySelector onSelectCity={setSelectedCity} />
      ) : (
        <MapView
          city={selectedCity}
          onBack={() => setSelectedCity(null)}
          user={user}
          sharedRestaurantId={sharedRestaurantId}
        />
      )}
    </div>
  );
}

export default App;